import { put, call, takeLatest, all } from 'redux-saga/effects';

import { error } from 'notifications/actions';
import * as api from './api';
import * as types from './types';
import * as actions from './actions';
import { paymentArrangementRequest } from '../app/routes';

export function* arrangePayment({ payload: { purchaseId, attrs } }) {
  try {
    yield put(actions.arrangePaymentPending());
    const resp = yield call(api.arrangePurchase, purchaseId, attrs);
    yield put(actions.arrangePaymentSucceeded(resp));
    yield put(paymentArrangementRequest({ success: 'true' }));
  }
  catch (err) {
    yield put(actions.arrangePaymentFailed());
    yield put(error('paymentArrangementRequest', err.message));
  }
}

export function* watchArrangePayment() {
  yield takeLatest(types.ARRANGE_PAYMENT, arrangePayment);
}

export function* watchPaymentArrangement() {
  yield all([
    call(watchArrangePayment),
  ]);
}